<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Personal Details</a>
            </div>
        </div>
        <div class="box-body">
            <div v-if="status===0">

            </div>
            <div class="account-auth" v-else-if="status===1"> <!-- question -->
                <div class="account-auth-top">
                    <el-steps :active="step" align-center>
                        <el-step title="STEP 1" description="Select Trading Account"></el-step>
                        <el-step title="STEP 2" description="Personal Details"></el-step>
                        <el-step title="STEP 3" description="Financial Details"></el-step>
                        <el-step title="STEP 4" description="Bank Details"></el-step>
                        <el-step title="STEP 5" description="Employment and Investment Experience"></el-step>
                        <el-step title="STEP 6" description="Upload Documents"></el-step>
                    </el-steps>
                </div>
                <div class="account-auth-view">
                    <div class="step1" v-if="step===0||step===1">
                        <SelectTradingAccount @onStopIndex="stop_index"/>
                    </div>
                    <div class="step1" v-else-if="step===2">
                        <PersonalDetails  @onStopIndex="stop_index"/>
                    </div>
                    <div class="step1" v-else-if="step===3">
                        <FinancialDetails  @onStopIndex="stop_index"/>
                    </div>
                    <div class="step1" v-else-if="step===4">
                    <BankDetails @onStopIndex="stop_index"/>
                    </div>
                    <div class="step1" v-else-if="step===5">
                        <InvestmentExperience   @onStopIndex="stop_index" @onStatus="on_status"/>
                    </div>
                    <div class="step1" v-else-if="step===6">
                        <UploadDocuments  @onStopIndex="stop_index"/>
                    </div>
                </div>
            </div>

            <div v-else-if="status===3">  <!-- success -->
              <Info/>
            </div>

            <div v-else-if="status===4"> <!-- fail -->
             <Failed/>
            </div>
        </div>
    </div>
</template>

<script>
import SelectTradingAccount from './DataCertification/SelectTradingAccount' // 1
import PersonalDetails from './DataCertification/PersonalDetails' // 2
import FinancialDetails from './DataCertification/FinancialDetails' // 3
import BankDetails from './DataCertification/BankDetails' // 4
import InvestmentExperience from './DataCertification/InvestmentExperience' // 5
import UploadDocuments from './DataCertification/UploadDocuments' // 6
import Info from './DataCertification/Info' // 认证成功信息显示
import Failed from './DataCertification/Failed' // 认证失败
import * as server from './action'

let msgboxOption = {
  dangerouslyUseHTMLString: true,
  center: true,
  customClass: 'account-auth',
  showClose: false
}

export default {
  data() {
    return {
      step: 1,
      status: 1,
      msgboxWarning: {
        ...msgboxOption,
        iconClass: 'ico-box ico-warning',
        confirmButtonText: 'Confirm'
      }
    }
  },
  async created() {
    this.status = 0
    await window.vuex_store.dispatch('initUserInfo')
    if (this.$store.state.user_info.certification_status) {
      this.status = 3
    } else {
      server.certification_apply_index('', true).then(res => {
        if (res.data.status === 'refuse') {
          this.step = 5
        } else {
          this.step = res.data.step
        }
        this.status = 1
        this.$alert(
          `
    Your responses will be used to determine whether we are able to open a
    trading account for you. Please ensure that you provide accurate
    responses to the following important questions. `,
          this.msgboxWarning
        ).then(() => {})
      })
    }
  },
  methods: {
    stop_index(index) {
      this.step = index
    },
    on_status(val) {
      this.status = val
    }
  },
  components: {
    SelectTradingAccount,
    PersonalDetails,
    FinancialDetails,
    InvestmentExperience,
    UploadDocuments,
    BankDetails,
    Info,
    Failed
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.account-auth {
  .account-auth-top {
    height: 135px;
    .el-step {
      position: relative;
      &.is-center .el-step__description {
        padding: 0;
      }
      .el-step__head {
        position: absolute;
        top: 85px;
        &.is-finish {
          border-color:  #0A95FF;
          .el-step__icon {
            background:  #0A95FF;
          }
        }
        .el-step__line-inner {
          border-width: 2px !important;
        }
        .el-step__icon {
          margin-top: 7px;
          width: 12px;
          height: 12px;
          border: none;
          background: #c0c4cc;
          .el-step__icon-inner {
            display: none;
          }
        }
      }
      &.is-horizontal {
        .el-step__line {
          height: 4px;
        }
      }
      .el-step__main {
        position: absolute;
        top: 0;
        width: 100%;
        .el-step__title {
          font-size: 20px;
        }
        .el-step__description {
          font-size: 14px;
        }
        .el-step__title.is-process {
          font-weight: normal;
          color: #303133;
        }
        .el-step__title.is-finish,
        .el-step__description.is-finish {
          color:  #0A95FF;
        }
        .el-step__description.is-process,
        .el-step__title.is-process,
        .el-step__description.is-wait,
        .el-step__title.is-wait {
          color: #888888;
        }
      }
    }
  }

  &-msgbox {
    &.el-message-box--center {
      width: 520px;
      padding: 30px 0 60px 0;
    }
    .ico-box {
      width: 60px;
      height: 60px;
      &.ico-success {
        background: url('~assets/img/ico-successful.png');
      }
      &.ico-failed {
        background: url('~assets/img/ico-failed.png');
      }
      &.ico-warning {
        background: url('~assets/img/ico-warning.png');
      }
    }

    button.el-button--primary {
      width: 253px;
      height: 42px;
      margin-top: 10px;
      background:  #0A95FF;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      &:focus,
      &:hover {
        color: #fff;
        opacity: 0.9;
      }
    }
  }
}
</style>
